import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTestAvailableCourseById } from 'app/actions/CourseActions';
import { getCourseTestAvailable } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function CourseTestAvailableContainer(props){

    let courseTestAvailable = useSelector(getCourseTestAvailable);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if (isEmpty(courseTestAvailable)) fetchCourseTestAvailableAction();
    }, []);

    const fetchCourseTestAvailableAction = () => dispatch(fetchTestAvailableCourseById(props.id, props.idTraining));
    courseTestAvailable.map(item => item['key'] = item.idTest);
    courseTestAvailable.map(item => item['disabled'] = false);
    return (props.children({ courseTestAvailable}));
}